import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const suggestedUsersList = createAsyncThunk("reportNews", async (_, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/suggested_nearby_users/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const NeighborhoodInviteSlice = createSlice({
    name: "NeighborhoodInvite",
    initialState: {
        neighborhoodInvite: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(suggestedUsersList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(suggestedUsersList.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodInvite = action.payload.nearby_users;
        });
        builder.addCase(suggestedUsersList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

export default NeighborhoodInviteSlice.reducer;